/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Subtask
 */
export interface Subtask {
    /**
     * 
     * @type {number}
     * @memberof Subtask
     */
    id: number;
    /**
     * 
     * @type {{ [key: string]: object | undefined; }}
     * @memberof Subtask
     */
    kwargs: { [key: string]: object | undefined; };
    /**
     * 
     * @type {{ [key: string]: object | undefined; }}
     * @memberof Subtask
     */
    graphLayout?: { [key: string]: object | undefined; };
    /**
     * 
     * @type {string}
     * @memberof Subtask
     */
    readonly validationError: string;
    /**
     * 
     * @type {string}
     * @memberof Subtask
     */
    trigger?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subtask
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Subtask
     */
    noopDontSave?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Subtask
     */
    noConcurrency?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Subtask
     */
    timeout?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Subtask
     */
    logVariable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Subtask
     */
    task?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subtask
     */
    conditionVariable?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subtask
     */
    conditionValue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Subtask
     */
    sync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Subtask
     */
    queue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Subtask
     */
    enqueueAtFront?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Subtask
     */
    parent: number;
    /**
     * 
     * @type {number}
     * @memberof Subtask
     */
    relativeTo?: number | null;
}

export function SubtaskFromJSON(json: any): Subtask {
    return SubtaskFromJSONTyped(json, false);
}

export function SubtaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subtask {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kwargs': json['kwargs'],
        'graphLayout': !exists(json, 'graph_layout') ? undefined : json['graph_layout'],
        'validationError': json['validation_error'],
        'trigger': !exists(json, 'trigger') ? undefined : json['trigger'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'noopDontSave': !exists(json, 'noop_dont_save') ? undefined : json['noop_dont_save'],
        'noConcurrency': !exists(json, 'no_concurrency') ? undefined : json['no_concurrency'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
        'logVariable': !exists(json, 'log_variable') ? undefined : json['log_variable'],
        'task': !exists(json, 'task') ? undefined : json['task'],
        'conditionVariable': !exists(json, 'condition_variable') ? undefined : json['condition_variable'],
        'conditionValue': !exists(json, 'condition_value') ? undefined : json['condition_value'],
        'sync': !exists(json, 'sync') ? undefined : json['sync'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
        'enqueueAtFront': !exists(json, 'enqueue_at_front') ? undefined : json['enqueue_at_front'],
        'parent': json['parent'],
        'relativeTo': !exists(json, 'relative_to') ? undefined : json['relative_to'],
    };
}

export function SubtaskToJSON(value?: Subtask | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'kwargs': value.kwargs,
        'graph_layout': value.graphLayout,
        'trigger': value.trigger,
        'name': value.name,
        'noop_dont_save': value.noopDontSave,
        'no_concurrency': value.noConcurrency,
        'timeout': value.timeout,
        'log_variable': value.logVariable,
        'task': value.task,
        'condition_variable': value.conditionVariable,
        'condition_value': value.conditionValue,
        'sync': value.sync,
        'queue': value.queue,
        'enqueue_at_front': value.enqueueAtFront,
        'parent': value.parent,
        'relative_to': value.relativeTo,
    };
}


